<template>
  <!-- 司机管理 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" formItemBox">
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" v-model="searchFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" v-model="searchFrom.mobile"></el-input>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
                <el-input  placeholder="" v-model="searchFrom.licenseNum"></el-input>
              </el-form-item>
              <el-form-item label="驾驶证档案号:" prop="certificateNum">
              <el-input  placeholder="" v-model="searchFrom.certificateNum"></el-input>
              </el-form-item>
                <el-form-item label="从业资格证号:" prop="qualificationNum">
                <el-input  placeholder="" v-model="searchFrom.qualificationNum"></el-input>
              </el-form-item>
              <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="searchFrom.driverClassify">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="创建时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="所属车队:" prop="tenantId" v-if="searchFrom.isZhb == '0'">
                <el-select placeholder="请选择" v-model="searchFrom.tenantId" filterable @change="fleetChange">
                  <el-option
                    v-for="item in fleetData"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00BP000B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP000B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP000B002"  v-if="btnFlg[2]">
            <el-button type="primary"  @click="addDeiver">新增</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP000B003"  v-if="btnFlg[3]">
            <el-button type="danger" @click="delDeiver">删除</el-button>
          </el-form-item>
          <el-form-item btnCode='00BP000B006' v-if="btnFlg[6]">
            <el-button type="primary"  @click="THimportFn">导入</el-button>
          </el-form-item>
          <el-form-item btnCode='00BP000B007' v-if="btnFlg[7]">
            <el-button type="primary" @click="modelDown">模板下载</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[8]" >
            <el-button type="primary" @click="bdcysFN">绑定承运商</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%"   style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="00BP000B004"  v-if="btnFlg[4]" @click="modifyDeiver(scope.row)">修改</el-button>
              <el-button type="text" size="mini" btnCode="00BP000B005"  v-if="btnFlg[5]" v-show="scope.row.accountStatus!=2" @click="ktzhFn(scope.row)">开通账号</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="accountStatus" label="开通状态" >
          <template scope="scope">
            {{[ "未开通", "已开通" ][scope.row.accountStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="name" width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
        <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
        <el-table-column prop="identityNo" width="200" label="身份证号"></el-table-column>
        <el-table-column property="driverClassify" label="司机所属" >
          <template scope="scope">
            {{[ "市场司机", "自家司机" ][scope.row.driverClassify-1]}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="bankCard" width="120" :show-overflow-tooltip="true" label="银行卡号"></el-table-column>
        <el-table-column prop="bankName" width="150" :show-overflow-tooltip="true"  label="开户行"></el-table-column>
        <el-table-column prop="bankCardUser" label="收款人"></el-table-column> -->
        <el-table-column prop="tenantName" width="200" label="所属车队" v-if="searchFrom.isZhb == '0'"></el-table-column>
        <el-table-column prop="licenseNum" width="120" :show-overflow-tooltip="true"  label="驾驶证号"></el-table-column>
        <el-table-column prop="certificateNum" width="160" :show-overflow-tooltip="true"  label="驾驶证档案号"></el-table-column>
        <el-table-column prop="qualificationNum" width="160" :show-overflow-tooltip="true"  label="从业资格证号"></el-table-column>
        <el-table-column prop="ext1" width="160"  v-if="btnFlg[8]" :show-overflow-tooltip="true"  label="绑定承运商"></el-table-column>
       <el-table-column property="fiveInsurances" label="五险" >
          <template scope="scope">
            {{[ "否", "是" ][scope.row.fiveInsurances]}}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="160"   label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat"  label="创建时间"></el-table-column>
        <!-- <el-table-column label="证件查看">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="amendPick(scope.$index, scope.row)">查看</el-button>
                </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="开通账号" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="kztzVisible" @close="closeDialog" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="ktzhFrom" ref="ktzhFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
              <el-form-item label="账号:" prop="account">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="ktzhFrom.account"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="kztzVisible = false">取 消</el-button>
        <el-button type="primary" @click="KTsaveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 司机的新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="900px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder="" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" @blur="CPHfn()"   maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder=""  maxlength="11" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile"></el-input>
              </el-form-item>
              <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="addFrom.driverClassify">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.licenseNum" ></el-input>
              </el-form-item>
              <!-- <el-form-item label="银行卡号:" prop="bankCard">
              <el-input  placeholder="" onkeyup="value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$& ')"  maxlength="25" v-model="addFrom.bankCard"></el-input>
              </el-form-item>
              <el-form-item label="开户行:" prop="bankName">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.bankName"></el-input>
              </el-form-item>
              <el-form-item label="收款人:" prop="bankCardUser">
                <el-input  placeholder="" maxlength="10" v-model.trim="addFrom.bankCardUser"></el-input>
              </el-form-item> -->
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.certificateNum"></el-input>
              </el-form-item>
              <el-form-item label="从业资格证号:" prop="qualificationNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum"></el-input>
              </el-form-item>
              <el-form-item label="五险:" prop="fiveInsurances">
                <el-radio-group v-model="addFrom.fiveInsurances">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="所属车队:" prop="tenantId" v-if="searchFrom.isZhb == '0'">
                <el-select placeholder="请选择" v-model="addFrom.tenantId" filterable @change="fleetChange">
                  <el-option
                    v-for="item in fleetData"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-button type="primary" @click="saveFn('addFrom')">保存</el-button>
        </div>
        </el-form>
        <hr>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-credit-card iconFont" aria-hidden="true"></i>收款信息</span>
            <span class="red">最多三个收款信息</span>
          </h4>
          <el-button type="primary" @click="addHkFn()">新增</el-button>
        </div>
         <el-form :inline="true" :rules="rules"  :model="FKfrom" ref="FKfrom" :inline-message="false" class="demo-form-inline FKbox" label-width="110px" size="mini">
        <el-table :data="FKfrom.SKlist"  ref="table1"   bordersize="mini"  class="table"  style="width: 100%" center  >
        <el-table-column label="银行卡号" width="200">
          <template slot-scope="scope">
            <el-form-item v-if='isEdits[scope.$index]'  :prop="'SKlist.' +scope.$index + '.bankCard'" :key="'bankCard'+FKfrom.SKlist[scope.$index].key" :rules="rules.bankCard">
              <el-input  placeholder="" onkeyup="value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$& ')"  maxlength="25" v-model="FKfrom.SKlist[scope.$index].bankCard"></el-input>
            </el-form-item>
            <span v-if='!isEdits[scope.$index]'>{{FKfrom.SKlist[scope.$index].bankCard}}</span>
          </template>
        </el-table-column>
          <el-table-column label="开户行" width="200">
          <template slot-scope="scope">
            <el-form-item v-if='isEdits[scope.$index]'  :prop="'SKlist.' +scope.$index + '.bankName'" :key="'bankName'+FKfrom.SKlist[scope.$index].key" :rules="rules.bankName">
              <el-input  placeholder=""   maxlength="25" v-model="FKfrom.SKlist[scope.$index].bankName"></el-input>
            </el-form-item>
            <span v-if='!isEdits[scope.$index]'>{{FKfrom.SKlist[scope.$index].bankName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="收款人" width="200">
          <template slot-scope="scope">
            <el-form-item v-if='isEdits[scope.$index]'  :prop="'SKlist.' +scope.$index + '.bankCardUser'" :key="'bankCardUser'+FKfrom.SKlist[scope.$index].key" :rules="rules.bankCardUser">
              <el-input  placeholder=""   maxlength="25" v-model="FKfrom.SKlist[scope.$index].bankCardUser"></el-input>
            </el-form-item>
            <span v-if='!isEdits[scope.$index]'>{{FKfrom.SKlist[scope.$index].bankCardUser}}</span>
          </template>
        </el-table-column>
        <el-table-column label="默认" width="60">
          <template slot-scope="scope">
             {{[ "是", "否"][scope.row.isDefault-1]}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.isDefault!=1" @click="delFn(scope.row,scope.$index)">删除</el-button>
            <el-button type="text" size="mini" v-if='isEdits[scope.$index]' @click="FKsave(scope.row,scope.$index)">保存</el-button>
            <el-button type="text" size="mini" v-if='!isEdits[scope.$index]' @click="FKedit(scope.row,scope.$index)">修改</el-button>
            <el-button type="text" size="mini" v-if='!isEdits[scope.$index]&&scope.row.isDefault!=1' @click="setMfn(scope.row,scope.$index)">设为默认</el-button>
          </template>
        </el-table-column>
      </el-table>
       </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 绑定承运商 -->
    <el-dialog  title="绑定承运商" :close-on-click-modal="false" :close-on-press-escape="false"  @close="bdcysFlag = false"  :visible.sync="bdcysFlag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="bdcysForm" :model="bdcysForm"  class="demo-form-inline jiaoyan"  label-width="90px"  size="mini"  >
         <el-form-item label="承运商 :" prop="customerName">
            <el-select  v-model="bdcysForm.customerName"  placeholder="请选择" clearable   style="width:176px">
              <template  v-for="item in CYSList">
                    <el-option  :label="item.customerName"  :value="item.customerName" :key="item.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bdcysFlag = false">取 消</el-button>
        <el-button type="primary" @click="cysSaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn, getAttributeA } from '@/utils/getButton'
import { findCustomerInfoList } from '@/api/newTMS'
import { cDlist, cDadd, cDupdate, cDdelete, getCDriverInfo, openAccount,
  detailDriver, CDBadd, CDBupdate, updateDefault, CDBlist, CDBdelete, impVehicleInfoExcelDrive, selectCustomerList, driverBindCustomer } from '@/api/vgs-driver'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        isZhb: null
      },
      FKfrom: {
        SKlist: []
      },
      isEdits: [],
      isAdd: false,
      tableList: [],
      loading: 'false',
      addFrom: {},
      ktzhFrom: {},
      title: '新建司机信息',
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        bankCard: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bankCardUser: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        tenantId: [
          { required: true, message: '请选择所属车队', trigger: ['blur', 'change'] }
        ]
        // customerName: [
        //   { required: true, message: '请选择承运商', trigger: ['blur', 'change'] }
        // ]
      },
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '市场司机'
        },
        {
          value: 2,
          label: '自家司机'
        }
      ],
      total: 0,
      value2: '',
      ids: [],
      // 小何协商删除和开通需要添加tenantId参数 租户code
      tenantIds: [],
      dialogVisible: false,
      kztzVisible: false,
      disabled: false,
      hideUploadEditA: false,
      hideUploadEditB: false,
      hideUploadEditC: false,
      hideUploadEditD: false,
      btnFlg: [],
      btnIdArr: ['00BP000B000', '00BP000B001', '00BP000B002',
        '00BP000B003', '00BP000B004', '00BP000B005', '00BP000B006', '00BP000B007', '00BM000100'],
      importDialog: false,
      fleetData: [],
      bdcysFlag: false,
      bdcysForm: {},
      CYSList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driver')
    this.getAttributeA()
    // this.getList(this.searchFrom)
    this.selectCustomerList()
    findCustomerInfoList({ businessType: 2 }).then(res => { this.CYSList = res })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 绑定承运商
    bdcysFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.bdcysForm.ids = selectData.map(itme => itme.id)
      this.bdcysFlag = true
    },
    cysSaveFn () {
      let json = this.CYSList.filter(item => item.customerName == this.bdcysForm.customerName)
      if (json.length > 0) {
        this.bdcysForm.customerTaxId = json[0].customerTaxId
        this.bdcysForm.customerId = json[0].id
      } else {
        this.$set(this.bdcysForm, 'customerName', null)
        this.bdcysForm.customerTaxId = null
        this.bdcysForm.customerId = null
      }

      this.$refs.bdcysForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverBindCustomer(this.bdcysForm).then(res => {
            loading.close()
            this.bdcysFlag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: false,
              duration: 3000,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    getAttributeA () {
      getAttributeA('ARRisShowFleet', localStorage.getItem('tenantCode')).then(res => {
        console.log(res, '123')
        // 0 是 1否
        this.searchFrom.isZhb = res[0]
        this.getList(this.searchFrom)
      })
    },
    // 中厚板获取所属车队
    selectCustomerList () {
      selectCustomerList({}).then(res => {
        console.log(res, '车队')
        this.fleetData = res
      })
    },
    fleetChange (e) {
      this.fleetData.forEach(item => {
        if (e == item.code) {
          this.$set(this.addFrom, 'tenantName', item.name)
        }
      })
    },
    // 添加付款信息
    addHkFn () {
      if (this.FKfrom.driverId) {
        if (this.FKfrom.SKlist.length >= 3) {
          this.$alert('最多只能添加三条付款信息', '系统提示')
        } else if (!this.isEdits.every(item => { return !item })) {
          this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
        } else {
          this.FKfrom.SKlist.push({ key: this.FKfrom.SKlist.length })
          this.isEdits.push(true)
        }
      } else {
        this.$alert('请先保存司机基本信息', '系统提示')
      }
    },
    // 删除银行卡
    delFn (row, index) {
      if (row.id) {
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          CDBdelete({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getBankList()
          }).catch(error => {
            this.$message({
              showClose: false,
              message: error.message,
              duration: 3000,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      } else {
        this.FKfrom.SKlist.splice(index, 1)
        this.isEdits.splice(index, 1)
      }
    },
    // 设置默认
    setMfn (row, index) {
      if (!this.isEdits.every(item => { return !item })) {
        this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
      } else {
        this.$confirm('是否将该卡设置为默认?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateDefault({ id: row.id, isDefault: 1 }).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getBankList()
          }).catch(error => {
            this.$message({
              showClose: false,
              message: error.message,
              duration: 3000,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    // 付款修改
    FKedit (row, index) {
      if (this.FKfrom.driverId) {
        if (!this.isEdits.every(item => { return !item })) {
          this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
        } else {
          this.$set(this.isEdits, index, true)
        }
      } else {
        this.$alert('请先保存司机基本信息', '系统提示')
      }
    },
    // 付款保存
    FKsave (row, index) {
      let that = this
      that.$refs.FKfrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (row.id) {
            row.driverId = this.FKfrom.driverId
            CDBupdate(row).then(res => {
              loading.close()
              this.getBankList()
            }).catch(error => {
              this.$message({
                showClose: false,
                duration: 3000,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            row.driverId = this.FKfrom.driverId
            CDBadd(row).then(res => {
              loading.close()
              this.getBankList()
            }).catch(error => {
              this.$message({
                showClose: false,
                duration: 3000,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 获取银行卡列表
    getBankList () {
      CDBlist({ driverId: this.FKfrom.driverId }).then(res => {
        this.FKfrom.SKlist = res
        this.isEdits = []
        res.forEach(item => {
          this.isEdits.push(false)
        })
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cDlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 开通账号
    ktzhFn (row) {
      this.kztzVisible = true
      this.ktzhFrom.driverId = row.id
      this.$set(this.ktzhFrom, 'account', row.mobile)
      this.$set(this.ktzhFrom, 'isZhb', this.searchFrom.isZhb)
      this.$set(this.ktzhFrom, 'tenantIds', row.tenantId)
      this.$set(this.ktzhFrom, 'tenantName', row.tenantName)
    },
    KTsaveFn () {
      this.$refs.ktzhFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          openAccount(this.ktzhFrom).then(res => {
            loading.close()
            this.kztzVisible = false
            this.$message({
              message: '开通成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: false,
              duration: 3000,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 司机添加
    addDeiver () {
      this.title = '新建司机信息'
      this.dialogVisible = true
      this.isAdd = true
      this.$set(this.addFrom, 'fiveInsurances', 0)
    },
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        getCDriverInfo({ identityNo: this.addFrom.identityNo }).then(res => {
          loading.close()

          if (res.id) {
            this.addFrom = res
            this.FKfrom.SKlist = res.cDriverBankCardList
            this.isEdits = []
            res.cDriverBankCardList.forEach(item => {
              this.isEdits.push(false)
            })
          } else {
            let identityNo = this.addFrom.identityNo
            this.addFrom = {
              identityNo: identityNo,
              fiveInsurances: 0
            }
          }
        }).catch(error => {
          this.$message({
            showClose: false,
            duration: 3000,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 修改
    modifyDeiver (row) {
      this.title = '修改司机信息'
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = JSON.parse(JSON.stringify(row))
        this.$set(this.addFrom, 'fiveInsurances', Number(res.fiveInsurances))
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.isEdits = []
        res.cDriverBankCardList.forEach(item => {
          this.isEdits.push(false)
        })
        this.FKfrom.driverId = res.id
        this.dialogVisible = true
        this.isAdd = false
      }).catch(error => {
        this.$message({
          showClose: false,
          duration: 3000,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cDadd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.FKfrom.driverId = res.id
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: false,
                duration: 3000,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cDupdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: false,
                duration: 3000,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      // 司机管理和车辆管理的删除功能改成仅支持单条删除（韦苗苗）
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('只能选择一条数据进行操作')
      } else {
        this.ids = []
        this.tenantIds = []
        selectData.some(item => {
          this.ids.push(item.id)
          this.tenantIds.push(item.tenantId)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cDdelete({ ids: this.ids, isZhb: this.searchFrom.isZhb, tenantIds: this.tenantIds }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: false,
              duration: 3000,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
      this.addFrom = {}
      this.ktzhFrom = {}
      this.$refs.table.clearSelection()
      this.isEdits = []
      this.rules1 = []
      this.FKfrom.SKlist = []
      this.FKfrom.driverId = null
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        isZhb: this.searchFrom.isZhb
      }
      this.getAttributeA()
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/driver1/%E5%8F%B8%E6%9C%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    // 导入
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impVehicleInfoExcelDrive(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.$message({
          showClose: false,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: false,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.searchBtnBox{
  margin: 0;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
